import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from '@/checkout/components/CheckoutDescription/CheckoutDescription';
import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import { FormikInputPassword } from '@/general/components/forms/FormikInput/FormikInputPassword';
import { InputCheckboxFormik } from '@/general/components/forms/Input/InputCheckboxFormik';
import { Checkbox } from '@/general/components/forms/Input/atoms/OptionFieldInput';
import { getMicrocopy } from '@/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';
import {
  PersonalizedQuoteFormProps,
  SignupFormValidation,
  SignupFormValues,
  isCheckNewsAndMarketingOptions,
} from './PersonalizedQuoteForm.type';

const initialValues: SignupFormValues = {
  newPassword: '',
  newsAndMarketing: isCheckNewsAndMarketingOptions[0]['value'] as any,
};

export const SignupForm: FC<PersonalizedQuoteFormProps<SignupFormValues> & { email: string; phone: string }> = ({
  onSubmit,
  values,
  onBack,
  email,
  phone,
}) => {
  const checkboxOptions = isCheckNewsAndMarketingOptions.map((item) => ({
    value: item.value,
    label: getMicrocopy(item.label, true),
  }));

  return (
    <>
      <CheckoutDescription
        title={getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_SIGNUP_HEADER)}
        description={getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_SIGNUP_HEADER_DESCRIPTION)}
        onBack={onBack}
      />
      <div className={styles.loanDetails}>
        <Formik
          initialValues={{ ...initialValues, ...values }}
          validateOnChange={false}
          onSubmit={onSubmit}
          validationSchema={SignupFormValidation}
        >
          {(props) => (
            <div className={styles.signupForm}>
              <Form className={styles.form}>
                <div className={styles.infoWrapper}>
                  <div className={styles.infoContainer}>
                    <div className={styles.label}>Email address</div>
                    <div className={styles.info}>{email}</div>
                  </div>
                  <div className={styles.infoContainer}>
                    <div className={styles.label}>Mobile number</div>
                    <div className={styles.info}>{phone}</div>
                  </div>
                </div>
                <FormikInputPassword
                  name="newPassword"
                  label="Create a password"
                  withHelpText
                  disabled={props.isSubmitting}
                  autoComplete="new-password"
                />

                <div className={styles.checkbox}>
                  <InputCheckboxFormik
                    id="newsAndMarketing"
                    name="newsAndMarketing"
                    options={checkboxOptions}
                    disabled={props.isSubmitting}
                    variant="isolated"
                    inputIcon={Checkbox}
                  />
                </div>

                <div className={styles.terms}>
                  {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_SIGNUP_TERM_AND_POLICY, true)}
                </div>
                <footer className={styles.footer}>
                  <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                    {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_SIGNUP_CTA)}
                  </Button>
                </footer>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    </>
  );
};
